import React, { Fragment, useContext } from 'react'
import { CardElement } from '@stripe/react-stripe-js';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { Button, List, Message, Divider, Accordion, Label, Form } from 'semantic-ui-react'
import { Text, Translate, LanguageContext } from '../../helpers/language';
import SubscriptionItem from '../User/SubscriptionItem'


const CardForm = (props) => {
  const languageContext = useContext(LanguageContext);
  const stripe = useStripe();
  const elements = useElements();
  const { errors,
          setErrors, 
          withCard, 
          setWithCard, 
          curUser, 
          handleResult, 
          setCurUser,
          validateUser,
          prices,
          processing,
          showBillingInfo,
          billingInfo
          } = props;

  const handleChange = ({ error, complete }) => {
      if (error) {
        //messages from stripe are translated already
        setErrors({ ...errors ,cardError: error.message });
      }
      else {
        setErrors({ ...errors ,cardError: '' });
      }
    };

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    try {
      const validateErrors = validateUser();
      if (validateErrors) {
        setErrors(validateErrors);
      } else if (withCard) {
          const cardElement = elements.getElement(CardElement);
          const { token } = await stripe.createToken(cardElement);
          if(token !== undefined){
            handleResult(token)
          }
      } else {
        handleResult()
      }
    } catch (exc) {
      console.error(exc);
    }
  };
  const createOptions = () => {
      return {
        style: {
          base: {
            fontSize: '16px',
            color: '#424770',
            fontFamily: 'Open Sans, sans-serif',
            letterSpacing: '0.025em',
            border: '4px solid red',
            '::placeholder': {
              color: '#aab7c4',
            },
          },
          invalid: {
            color: '#c23d4b',
          },
        }
      }
    }

  const handleChangePlan = (e, { value }) => {
    setErrors({...errors, plan: ''});
    setCurUser({ ...curUser, plan: value });
  }
  return (
      <div>
          <form onSubmit={handleSubmit}> 
          <Form.Group>
            <Form.Checkbox onChange={() => setWithCard(!withCard)} checked={withCard} label={Translate(languageContext,'with_subscription') } />
          </Form.Group>  
          {
            withCard &&        
            <Accordion>
              <Accordion.Title
                active={withCard}
                index={0}
                onClick={() => setWithCard(!withCard)}
                style={{textAlign:'left', fontSize: withCard ? '1.17em': '', fontWeight: 'bold'}}
              >             
                <div style={{textAlign: 'center', marginTop: '-1.17em'}}>
                  <Text tid='subscription_add' />
                </div>                                      
              </Accordion.Title>
              <Accordion.Content active={withCard} style={{margin: '10px'}}>                 
                  <Fragment>
                  { errors.plan &&
                    <Message
                      negative
                      header={errors.plan}
                    />
                  }
                  <List celled align='left'>
                    {prices.map((price) =>
                      <SubscriptionItem key={price.id} handlePlanChange={handleChangePlan} plan={price} selected={curUser.plan === price.id} isCurrentPlan={false} />                      
                    )}                        
                  </List>                 
                    <CardElement className='check-box-and-card'
                        onChange = {handleChange}
                        options = {createOptions()}                     
                    />
                    { errors.cardError  &&
                      <Label basic color='red' pointing>
                        {errors.cardError}
                      </Label>
                    }
                  <br />               
                  </Fragment>                        
              </Accordion.Content>
            </Accordion>    
          }           
          <Button className='lisia-blue' disabled={ processing || ((showBillingInfo && (billingInfo.is_error || !billingInfo.is_data_ok)) || (withCard && ((errors.cardError && errors.cardError !== '' && errors.cardError.length > 0) || curUser.plan === '')))} type='submit' style={{width: '100%'}}>
          <Text tid='submit'/>
          </Button>
          <Divider />
          </form>
      </div>
  )
}

export default CardForm